D.Social = {
	auth: function(service, remember){
		remember = remember === true;
		let url = new Url();
		let get = new Get(url.href);
		let redirect = '';
		if( get.is('redirect') ){
			redirect = get.v('redirect');
		}
		new RPC('/api/web_rpc.php').send('getAuthUrl', {
			service: service,
			redirect: redirect,
			remember: remember
		}, D.Social._onAuth);
	},

	_onAuth: function(re){
		if( re && re.url ){
			window.location.href = re.url;
		}
	},

	google: function(remember){
		remember = remember === true;
		D.Social.auth('google', remember);
	},

	facebook: function(remember){
		remember = remember === true;
		D.Social.auth('facebook', remember);
	},

	draugiem: function(remember){
		remember = remember === true;
		D.Social.auth('draugiem', remember);
	},

	apple: function(remember){
		remember = remember === true;
		D.Social.auth('apple', remember);
	}
};
